import React from 'react';
import { Link, NavLink } from 'react-router-dom';
import PropTypes from 'prop-types';
import { Box, Divider, Drawer, Typography, useMediaQuery } from '@mui/material';
import { NavItem } from './nav-item';
import { logout } from '../actions/access.actions';
import { connect, useDispatch } from 'react-redux';
import _ from 'lodash';
import ShoppingCartIcon from '@mui/icons-material/ShoppingCart';
import SettingsIcon from '@mui/icons-material/Settings';
import CodeIcon from '@mui/icons-material/Code';
import PhoneIphoneIcon from '@mui/icons-material/PhoneIphone';
import LogoutIcon from '@mui/icons-material/Logout';

import WebhookIcon from '@mui/icons-material/Webhook';
import PeopleIcon from '@mui/icons-material/People';
import FormatQuoteIcon from '@mui/icons-material/FormatQuote';
import TokenIcon from '@mui/icons-material/Token';
import ArticleIcon from '@mui/icons-material/Article';
import GitHubIcon from '@mui/icons-material/GitHub';
import SummarizeIcon from '@mui/icons-material/Summarize';
import ChatIcon from '@mui/icons-material/Chat';
import PeopleOutlineIcon from '@mui/icons-material/PeopleOutline';
import AnalyticsIcon from '@mui/icons-material/Analytics';
import InstagramIcon from '@mui/icons-material/Instagram';
import IntegrationInstructionsIcon from '@mui/icons-material/IntegrationInstructions';
import ContactPageIcon from '@mui/icons-material/ContactPage';
import AccountBoxIcon from '@mui/icons-material/AccountBox';
import ListAltIcon from '@mui/icons-material/ListAlt';
import WhatshotIcon from '@mui/icons-material/Whatshot';
import MemoryIcon from '@mui/icons-material/Memory';
import HandymanIcon from '@mui/icons-material/Handyman';
import DocumentScannerIcon from '@mui/icons-material/DocumentScanner';
import RecentActorsIcon from '@mui/icons-material/RecentActors';
import HowToRegIcon from '@mui/icons-material/HowToReg';
import QrCode2Icon from '@mui/icons-material/QrCode2';
import FormatColorTextIcon from '@mui/icons-material/FormatColorText';
import CameraAltIcon from '@mui/icons-material/CameraAlt';
import GroupsIcon from '@mui/icons-material/Groups';

const normalItems = [
	// { href: '/get-started', title: 'Get Started', icon: <MenuBookIcon fontSize="medium" /> },
	{
		href: '/',
		icon: <PhoneIphoneIcon fontSize="medium" />,
		title: 'Phones',
	},
	{
		href: '/developers',
		icon: <CodeIcon fontSize="medium" />,
		title: 'Developers',
		isClose: false,
		list: [
			{
				href: '/developers/documentation',
				icon: <ArticleIcon fontSize="small" />,
				title: 'Documentation',
			},
			{
				href: '/developers/token',
				icon: <TokenIcon fontSize="small" />,
				title: 'Product ID & Token',
			},
			{
				href: '/developers/webhook',
				icon: <WebhookIcon fontSize="small" />,
				title: 'Webhooks',
			},
			{
				href: '/developers/logs',
				icon: <SummarizeIcon fontSize="small" />,
				title: 'Logs',
			},
			{
				href: '/developers/instance-status',
				icon: <MemoryIcon fontSize="small" />,
				title: 'Instance Status',
			},
			{
				href: '/developers/wp_postman_documentation',
				icon: <GitHubIcon fontSize="small" />,
				title: 'Postman Collection',
			},
			{
				href: '/developers/group_action_logs',
				icon: <GroupsIcon fontSize="small" />,
				title: 'Group Action Logs',
			},
			{
				href: '/developers/group_info',
				icon: <PeopleOutlineIcon fontSize="small" />,
				title: 'Group Info',
			},
			{
                href: '/developers/logout_info',
                icon: <LogoutIcon fontSize="small" />,
                title: 'Logout Info',
            },
			// {
			// 	href: '',
			// 	icon: <CodeIcon fontSize="small" />,
			// 	title: 'Code Example',
			// },
		],
	},
	{
		href: '/integrations',
		icon: <IntegrationInstructionsIcon fontSize="medium" />,
		title: 'Integrations',
		isClose: false,
		list: [
			{
				href: '/integrations/sheets',
				icon: <ListAltIcon fontSize="small" />,
				title: 'Google Sheets',
			},
			{
				href: '/integrations/contacts',
				icon: <ContactPageIcon fontSize="small" />,
				title: 'Google Contacts',
			} /* ,
			{
				href: '/integrations/dialogflow',
				icon: <AccountTreeIcon fontSize="small" />,
				title: 'Dialogflow',
			}, */,
		],
	},
	{
		href: '/tools',
		icon: <HandymanIcon fontSize="medium" />,
		title: 'Tools',
		isClose: false,
		list: [
			{
				href: '/tools/base64encoder',
				icon: <DocumentScannerIcon fontSize="small" />,
				title: 'Base 64 Encoder',
			},
			{
				href: '/tools/vcardmaker',
				icon: <RecentActorsIcon fontSize="small" />,
				title: 'vCard Maker',
			},
			{
				href: '/tools/warmingup',
				icon: <WhatshotIcon fontSize="small" />,
				title: 'Warming Up',
			},
			{
				href: '/tools/whatsapp-check-numbers',
				icon: <HowToRegIcon fontSize="small" />,
				title: 'WhatsApp Number Checker',
			},
			{
				href: '/tools/multi-whatsapp-check-numbers',
				icon: <PeopleIcon fontSize="small" />,
				title: 'Multi WhatsApp Number Checker',
			},
			{
				href: '/tools/get-whatsapp-profile-picture',
				icon: <CameraAltIcon fontSize="small" />,
				title: 'WhatsApp Profile Picture Checker',
			},
			{
				href: '/tools/whatsapp-qr-code-generator',
				icon: <QrCode2Icon fontSize="small" />,
				title: 'WhatsApp QR Code Generator',
			},
			{
				href: '/tools/whatsapp-text-formatter',
				icon: <FormatColorTextIcon fontSize="small" />,
				title: 'WhatsApp Text Formatter',
			},
			{
				href: '/tools/json-escape-unescape',
				icon: <FormatQuoteIcon fontSize="small" />,
				title: 'JSON Escape / Unescape',
			},
		],
	},
	{
		href: '/subscription',
		icon: <ShoppingCartIcon fontSize="medium" />,
		title: 'Subscription',
	},

	{
		href: '/settings',
		icon: <SettingsIcon fontSize="medium" />,
		title: 'Settings',
	},
];

const liveItems = [
	// { href: '/get-started', title: 'Get Started', icon: <MenuBookIcon fontSize="medium" /> },
	{
		href: '/',
		icon: <PhoneIphoneIcon fontSize="medium" />,
		title: 'Phones',
	},
	{ href: '/chat', icon: <ChatIcon fontSize="medium" />, title: 'Live Chat' },
	{ href: '/instagram', icon: <InstagramIcon fontSize="medium" />, title: 'Instagram' },
	{ href: '/agents', icon: <PeopleOutlineIcon fontSize="medium" />, title: 'Agents' },
	{ href: '/analytic', icon: <AnalyticsIcon fontSize="medium" />, title: 'Analytic' },
	{
		href: '/developers',
		icon: <CodeIcon fontSize="medium" />,
		title: 'Developers',
		isClose: true,
		list: [
			{
				href: '/developers/documentation',
				icon: <ArticleIcon fontSize="small" />,
				title: 'Documentation',
			},
			{
				href: '/developers/token',
				icon: <TokenIcon fontSize="small" />,
				title: 'Product ID & Token',
			},
			{
				href: '/developers/webhook',
				icon: <WebhookIcon fontSize="small" />,
				title: 'Webhooks',
			},
			{
				href: '/developers/logs',
				icon: <SummarizeIcon fontSize="small" />,
				title: 'Logs',
			},
			{
				href: '/developers/wp_postman_documentation',
				icon: <GitHubIcon fontSize="small" />,
				title: 'Postman Collection',
			},
			{
				href: '/developers/instance-status',
				icon: <MemoryIcon fontSize="small" />,
				title: 'Instance Status',
			},
			{
				href: '/developers/group_action_logs',
				icon: <GroupsIcon fontSize="small" />,
				title: 'Group Action Logs',
			},
			{
				href: '/developers/group_info',
				icon: <PeopleOutlineIcon fontSize="small" />,
				title: 'Group Info',
			},
			{
                href: '/developers/logout_info',
                icon: <LogoutIcon fontSize="small" />,
                title: 'Logout Info',
            },
			// {
			// 	href: '',
			// 	icon: <CodeIcon fontSize="small" />,
			// 	title: 'Code Example',
			// },
		],
	},
	{
		href: '/integrations',
		icon: <IntegrationInstructionsIcon fontSize="medium" />,
		title: 'Integrations',
		isClose: false,
		list: [
			{
				href: '/integrations/sheets',
				icon: <ListAltIcon fontSize="small" />,
				title: 'Google Sheets',
			},
			{
				href: '/integrations/contacts',
				icon: <ContactPageIcon fontSize="small" />,
				title: 'Google Contacts',
			} /* ,
			{
				href: '/integrations/dialogflow',
				icon: <AccountTreeIcon fontSize="small" />,
				title: 'Dialogflow',
			}, */,
		],
	},
	{
		href: '/tools',
		icon: <HandymanIcon fontSize="medium" />,
		title: 'Tools',
		isClose: false,
		list: [
			{
				href: '/tools/base64encoder',
				icon: <DocumentScannerIcon fontSize="small" />,
				title: 'Base 64 Encoder',
			},
			{
				href: '/tools/vcardmaker',
				icon: <RecentActorsIcon fontSize="small" />,
				title: 'vCard Maker',
			},
			{
				href: '/tools/warmingup',
				icon: <WhatshotIcon fontSize="small" />,
				title: 'Warming Up',
			},
			{
				href: '/tools/whatsapp-check-numbers',
				icon: <HowToRegIcon fontSize="small" />,
				title: 'WhatsApp Number Checker',
			},
			{
				href: '/tools/multi-whatsapp-check-numbers',
				icon: <PeopleIcon fontSize="small" />,
				title: 'Multi WhatsApp Number Checker',
			},
			{
				href: '/tools/get-whatsapp-profile-picture',
				icon: <CameraAltIcon fontSize="small" />,
				title: 'WhatsApp Profile Picture Checker',
			},
			{
				href: '/tools/whatsapp-qr-code-generator',
				icon: <QrCode2Icon fontSize="small" />,
				title: 'WhatsApp QR Code Generator',
			},
			{
				href: '/tools/whatsapp-text-formatter',
				icon: <FormatColorTextIcon fontSize="small" />,
				title: 'WhatsApp Text Formatter',
			},
			{
				href: '/tools/json-escape-unescape',
				icon: <FormatQuoteIcon fontSize="small" />,
				title: 'JSON Escape / Unescape',
			},
		],
	},
	{
		href: '/subscription',
		icon: <ShoppingCartIcon fontSize="medium" />,
		title: 'Subscription',
	},
	{
		href: '/settings',
		icon: <SettingsIcon fontSize="medium" />,
		title: 'Settings',
	},
	// {
	// 	href: '/contact',
	// 	title: 'Contact',
	// },
];
var items;

export const DashboardSidebar = (props) => {
	const { instagram, open, onClose, user, isAgent } = props;
	let isAccordMenu;
	const dispatch = useDispatch();
	//const router = useRouter();
	const lgUp = useMediaQuery((theme) => theme.breakpoints.up('lg'), {
		defaultMatches: true,
		noSsr: false,
	});

	if (!isAgent || isAgent === 0) {
		items = normalItems;
		isAccordMenu = true;
	} else {
		isAccordMenu = true;
		items = liveItems;
	}

	if (!instagram) {
		_.remove(liveItems, { href: '/instagram' });
	}

	// var isDarkMode = '#fafafa';

	// const darkMode = localStorage.getItem('darkMode');
	// if (darkMode && darkMode === 'true') {
	// 	isDarkMode = 'linear-gradient(315deg, #485461 0%, #28313b 74%)';
	// } else {
	// 	isDarkMode = 'linear-gradient(315deg, #cbcbcb 0%, #494949 74%)';
	// }

	// console.log('isDarkMode ', isDarkMode);

	const content = (
		<>
			<Box
				id="sidebar-mytp"
				sx={{
					display: 'flex',
					flexDirection: 'column',
					height: '100%',
					textAlign: 'center',
				}}
			>
				<div>
					<Box sx={{ p: 3 }}>
						<NavLink to="/">
							<img src="/maytapi_full.svg" alt="maytapi" width={50} />
						</NavLink>
					</Box>
					<Box sx={{ px: 2 }}>
						<Box
							sx={{
								alignItems: 'center',
								backgroundColor: 'rgba(255,255,255, 0.08)',
								cursor: 'pointer',
								display: 'flex',
								justifyContent: 'space-between',
								px: 3,
								py: '11px',
								borderRadius: 1,
							}}
						>
							<Link to="/" style={{ width: '100%' }}>
								<Typography color="neutral.100" variant="subtitle1">
									MAYTAPI
								</Typography>
								<Typography color="neutral.400" variant="body2">
									WhatsApp API
								</Typography>
							</Link>
						</Box>
						{user.email ? (
							<Box sx={{ marginTop: '10px' }}>
								<Box
									sx={{
										alignItems: 'center',
										backgroundColor: 'rgba(255,255,255, 0.08)',
										cursor: 'pointer',
										display: 'flex',
										justifyContent: 'space-between',
										px: 3,
										py: '11px',
										borderRadius: 1,
									}}
								>
									<Link to="/settings" style={{ width: '100%' }}>
										{user.name && (
											<Typography color="neutral.200" variant="body2" className="limit-name">
												{user.name}
											</Typography>
										)}

										<Typography color="neutral.400" variant="body2" className="limit-name" sx={{ fontWeight: '700' }}>
											{user.email}
										</Typography>
									</Link>
								</Box>
							</Box>
						) : null}
					</Box>
				</div>
				<Divider
					sx={{
						borderColor: '#434343',
						my: 3,
					}}
				/>
				<Box sx={{ flexGrow: 1 }}>
					{items.map((item) => (
						<NavItem
							instagram={instagram}
							isAccordMenu={item.list && item.list.length ? true : false}
							clickValue={true}
							key={item.title}
							isClose={item.isClose}
							icon={item.icon}
							href={item.href}
							title={item.title}
							list={item.list}
						/>
					))}
				</Box>
				{/* <Box>
					<Box
						sx={{
							display: 'flex',
							mt: 2,
						}}
					>
						<NavItem
							newTab={true}
							icon={<img src="/maytapi_full_black.svg" alt="maytapi" width={16} />}
							title={'Old Maytapi Console'}
							href={'https://old.maytapi.com'}
						/>
					</Box>
				</Box> */}
				<Box>
					<NavItem icon={<LogoutIcon fontSize="small" />} title={'Logout'} onClick={() => dispatch(logout())} />
				</Box>
			</Box>
		</>
	);
	if (lgUp) {
		return (
			<Drawer
				anchor="left"
				open
				PaperProps={{
					sx: {
						background: 'linear-gradient(315deg, #485461 0%, #28313b 74%)',
						// color: '#FFFFFF',
						width: 280,
					},
				}}
				variant="permanent"
			>
				{content}
			</Drawer>
		);
	}

	return (
		<Drawer
			anchor="left"
			onClose={onClose}
			open={open}
			PaperProps={{
				sx: {
					background: 'linear-gradient(315deg, #485461 0%, #28313b 74%)',
					// color: '#FFFFFF',
					width: 280,
				},
			}}
			sx={{ zIndex: (theme) => theme.zIndex.appBar + 100 }}
			variant="temporary"
		>
			{content}
		</Drawer>
	);
};

DashboardSidebar.propTypes = {
	onClose: PropTypes.func,
	open: PropTypes.bool,
	user: PropTypes.object,
};
const stateToProps = (state) => ({ access: state.access, location: state.router.location, product: state.product.maytapi });

export default connect(stateToProps)(DashboardSidebar);
